import { useEffect, useState } from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

export function ReactQueryDevtoolsToggle() {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    const value = window.sessionStorage.getItem('REACT_QUERY_DEVTOOLS_TOGGLE');
    setShowDevtools(!!value);
  }, []);

  if (!showDevtools || process.env.NODE_ENV !== 'development') return null;
  return (
    <ReactQueryDevtools
      initialIsOpen={false}
      toggleButtonProps={{
        style: {
          width: '1rem',
          height: '1rem',
          bottom: '0.5rem',
          left: '-0.25rem',
        },
      }}
    />
  );
}
